import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import theme from 'theme/theme';
import { ContentCopyIcon } from 'assets/materialIcons/materialIcons';

const styles = {
    minWidth: '48px',
    borderRadius: '0',
};

const CopyToClipboard = (props) => {

    /**
     * This creates a new element to the document body.
     * It will use the textArea and select the value.
     *
     * @param {string} string
     */
    const handleCopyToClipboard = (string) => {
        if (!string) {
            return;
        }

        // Create an element.
        const el = document.createElement('textarea');

        // Add the string in the element.
        el.value = string;

        // Prevent it from being visible.
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';

        // Append the element to the body.
        document.body.appendChild(el);

        // Select the element.
        el.select();

        // Copy the element.
        document.execCommand('copy');

        // Remove the element.
        document.body.removeChild(el);
    };

    return (
        <FlatButton
            backgroundColor={ theme.palette.silver }
            hoverColor={ theme.palette.stardust }
            icon={ <ContentCopyIcon color={ theme.palette.white } /> }
            onTouchTap={ () => {
                return handleCopyToClipboard(props.string);
            } }
            style={ styles }
        />
    );
};

CopyToClipboard.propTypes = {
    string: PropTypes.string.isRequired,
};

export default CopyToClipboard;



// WEBPACK FOOTER //
// ./src/components/button/CopyToClipboard.js